import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class SpisakIskoriscenih extends BaseEntity{

    constructor(){
        super();
    }
    ID: number;
    Broj: string;
    Datum: NgbDate;    
    Iznos: number;
    ObjekatID: number;
    ObjekatNaziv: string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Checked = input.Checked;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.Iznos = input.Iznos;
        this.ObjekatID = input.ObjekatID;
        this.ObjekatNaziv = input.ObjekatNaziv;
        return this;
    }

    Serialize(input: SpisakIskoriscenih){
        return input;
    }

    GetInstance(){
        return this;
    }
}